import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import groq from 'groq';
import { SLUG } from 'lib/queries';
import { client } from 'lib/sanity';
import type { Slugs } from 'types/cms/Slugs';

type PartnersPageQuery = UseQueryResult & {
  data: Slugs;
};

export const PARTNERS_PAGE_KEY = 'partnersPage';

export const fetchPartners = async () => {
  const query = groq`
    *[ _type == 'timeline_partner']{
      ${SLUG},
    }
	`;

  const partners: Slugs = await client.fetch(query);
  return partners;
};

export const usePartners = () =>
  useQuery({
    queryKey: [PARTNERS_PAGE_KEY],
    queryFn: fetchPartners,
  }) as PartnersPageQuery;
